<template>
  <div>
    <CreativeSelector
      v-model="form.campaign.creatives"
      :resources="resources"
      :creative-type="form.campaign.creativeType"
      @select="previewCreative"
      @reload="reloadCreative"
    />
    <Preview ref="preview" :current-creative="currentCreative" />
  </div>
</template>

<script>
import CreativeSelector from './CampaignModalPageCreativeSelector'
import Preview from './CampaignModalPageCreativePreview'

export default {
  name: 'CampaignModalPageCreativeModeCampaign',
  components: { CreativeSelector, Preview },
  props: {
    form: {
      type: Object,
      required: true,
    },
    resources: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentCreative: null,
    }
  },
  computed: {
    confirmMessage() {
      const message = `クリエイティブが設定されていません。
        クリエイティブを設定するまで、このキャンペーンは配信されません。
        このまま進んでキャンペーンを作成した後にクリエイティブを入稿し、キャンペーンの編集画面からクリエイティブを設定してください。`
      return this.form.campaign.creatives.length === 0 ? message : ''
    },
  },
  methods: {
    previewCreative(creative) {
      this.currentCreative = creative
    },
    reloadCreative() {
      this.$refs.preview.reload()
    },
  },
}
</script>

<style></style>
